import { create } from "zustand";

interface FormState {
  // Current step for wizard/typeform modes
  currentStep: number;
  setCurrentStep: (step: number) => void;
  nextStep: () => void;
  prevStep: () => void;

  // Start time for duration tracking
  startTime: number | null;
  setStartTime: (time: number) => void;

  // Form submission state
  isSubmitting: boolean;
  setIsSubmitting: (submitting: boolean) => void;

  // Reset state
  reset: () => void;
}

export const useFormStore = create<FormState>((set) => ({
  currentStep: 0,
  setCurrentStep: (step) => set({ currentStep: step }),
  nextStep: () => set((state) => ({ currentStep: state.currentStep + 1 })),
  prevStep: () => set((state) => ({ currentStep: Math.max(0, state.currentStep - 1) })),

  startTime: null,
  setStartTime: (time) => set({ startTime: time }),

  isSubmitting: false,
  setIsSubmitting: (submitting) => set({ isSubmitting: submitting }),

  reset: () =>
    set({
      currentStep: 0,
      startTime: null,
      isSubmitting: false,
    }),
}));
